<template>
    <div class="log">
        <div class="top-box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>安全日志</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="tab-list d_flex a_c ">
                <h2>安全日志</h2>
            </div>
        </div>
        <div class="page-content p20">
            <div class="add-box bg_fff p20">
                <el-table :data="tableData" size="mini" border style="width: 100%"  v-loading="loading">
                    <el-table-column prop="title" label="标题" align="center"/>
                    <el-table-column prop="create_time" label="时间" align="center"/>
                </el-table>
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="pages"
                        :current-page="page"
 :page-size="20"
                        @current-change="handleCurrentChange"
                        style="margin-top: 20px; text-align: right;"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import {getLog} from '../../api/index'
    export default {
        name: "log",
        data(){
            return{
                tableData:[],
                loading:false,
                pages:1,
                page:1
            }
        },
        created(){
           this.getData();
        },
        methods:{
            getData(){
                this.loading=true;
                getLog({p:this.page}).then(res=>{
                    this.loading=false;
                    if(res.code==1){
                        this.tableData=res.data.list;
                        this.pages=res.data.total_num;
                    }
                })
            },
            handleCurrentChange(val){
                this.page = val;
                this.getData()
            },
        }
    }
</script>

<style scoped>

</style>
